export function clustersToRenderEntities(clusters) {
    return clusters.map((cluster) => {
        if (cluster.length === 1) {
            return cluster[0].marker;
        }
        const latitude = cluster.reduce((sum, coords) => sum + coords.marker.position.latitude, 0) / cluster.length;
        const longitude = cluster.reduce((sum, coords) => sum + coords.marker.position.longitude, 0) / cluster.length;
        return {
            type: 'cluster',
            key: cluster.map((coords) => coords.marker.parkingSlug).join('-'),
            position: { latitude, longitude },
            members: cluster.map((coords) => coords.marker),
        };
    });
}
